var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-layout-mask',[_c('m-layout',{staticClass:"left-sidebar-layout",class:{ compact: _vm.compactSidebar },staticStyle:{"width":"240px"}},[_c('m-scrollbar',[_c('result-menu')],1)],1),_vm._v(" "),_c('m-layout',{attrs:{"grow":""}},[_c('m-scrollbar',{attrs:{"id":"result-scrollbar"}},[_c('result-list')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4326728d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/results/ResultsLive.vue
// module id = null
// module chunks = 